import {
    FETCHING_ETAPAS_DATA,
    FETCHING_ETAPAS_DATA_SUCCESS,
    FETCHING_ETAPAS_DATA_FAILURE,
} from '../constants/actionTypes.js';
//import {API_URL} from "../constants/endpoints";
import api from '../api/etapas';

export const requestEtapas = (data) => {
    return async (dispatch) => {
        dispatch(getData(data));
        try {
            const [response, json] = await api('requestEtapas', data);
            json.statusCode = response.status;
            return dispatch(getDataSuccess(json));
        } catch (err) {
            console.log(err);
            return getDataFailure();
        }
    };
};


//API Requests
const getData = (data) => {
    return {
        type: FETCHING_ETAPAS_DATA,
        payload: data,
    };
};
const getDataSuccess = (data) => {
    return {
        type: FETCHING_ETAPAS_DATA_SUCCESS,
        data,
    };
};
const getDataFailure = () => {
    return {
        type: FETCHING_ETAPAS_DATA_FAILURE,
    };
};

